import React, { useState } from "react"
import { Container, Card, Button } from "reactstrap"
import { truncateDBOnly } from "../../../services/PrivateUse/truncateDb"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
const DbTruncate = () => {
  const companyname = localStorage.getItem("companyname")
  document.title = `Truncate${companyname ? ` | ${companyname}` : ""}`


  const [isLoading, setIsLoading] = useState(false)


  const truncateDb = async () => {
    setIsLoading(true);
    try {
      const response = await truncateDBOnly();
      toastSuccess(response?.message);
    } catch (error) {
      console.error("Error truncating DB:", error);
      toastError(error?.message || "Something went wrong while truncating the DB");
    } finally {
      setIsLoading(false);
    }
  };
  

  return (
    <div className="page-content page-content-index">
      <Container fluid className="">
        <Card className="invoice-main-card d-flex align-items-center justify-content-center">
          <div className="">
            <Button color="primary" onClick={truncateDb} disabled={isLoading}>
              {isLoading ? "Truncating..." : "Truncate"}
            </Button>
          </div>
        </Card>
      </Container>
    </div>
  )
}

export default DbTruncate
